export default __webpack_public_path__ + "static/media/mobile-campaign.28a715a8.gif";